import { Outlet } from "react-router-dom";

const StudentLayout = () => {
    return (
        <>
            <Outlet />
        </>
    );
}

export default StudentLayout;